// extracted by mini-css-extract-plugin
export default {"icon":"_5IOariLa80ftvzr3P6Pzns"};